import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c64d8f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "application-nav-bar",
  class: "app-header"
}
const _hoisted_2 = { class: "app-header__links" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "app-header__separator" }, null, -1))

import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import LogoSmall from '@exchange/assets/one-trading-white-icon.svg';
import Logo from '@exchange/assets/one-trading-white-logo.svg';
import { authService } from '@exchange/libs/auth/service/src';
import { LoginButtons } from '@exchange/libs/auth/ui/src';
import PrivacyButton from '@exchange/libs/balances/ui/src/lib/PrivacyButton.vue';
import { FundingActionsTriggers } from '@exchange/libs/components/shared/src';
import useMQBreakpoints from '@exchange/libs/composables/shared/src/lib/useMQBreakpoints';
import LanguageSetting from '@exchange/libs/settings/ui/src/lib/account/LanguageSetting.vue';

import AppHeaderNavLinks, { TradeNavLink } from './AppHeaderNavLinks.vue';
import PandaMenu from './PandaMenu.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppHeader',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const { isSMAndDown } = useMQBreakpoints();

const hasBeenAuthenticated = computed(() => authService.hasBeenAuthenticated);
const logo = computed(() => (isSMAndDown.value ? { component: LogoSmall, postfix: 'small' } : { component: Logo, postfix: 'big' }));

const navigateToExchange = () => {
  if (route.name === 'exchange') {
    return;
  }

  router.push({
    name: 'exchange',
  });
};

const onLinkClick = (v: TradeNavLink) => {
  let routeName: string;

  switch (v) {
    case TradeNavLink.futures:
      routeName = 'futures';
      break;
    case TradeNavLink.instantTrade:
      routeName = 'portfolio';
      break;
    case TradeNavLink.spot:
    default:
      routeName = 'exchange';
      break;
  }

  if (!routeName) {
    return;
  }

  router.push({
    name: routeName,
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(logo.value.component), {
      class: _normalizeClass(["app-header__logo", `app-header__logo--${logo.value.postfix}`]),
      onClick: navigateToExchange
    }, null, 8, ["class"])),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(AppHeaderNavLinks, { onLinkClicked: onLinkClick })
    ]),
    (hasBeenAuthenticated.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_unref(FundingActionsTriggers), {
            class: "app-header__funding-actions",
            short: true
          }),
          _hoisted_3
        ], 64))
      : _createCommentVNode("", true),
    _createVNode(LanguageSetting, {
      class: "app-header__language-select",
      toggle: true
    }),
    (hasBeenAuthenticated.value)
      ? (_openBlock(), _createBlock(PrivacyButton, {
          key: 1,
          "button-variant": "tertiary",
          class: "app-header__privacy-button"
        }))
      : _createCommentVNode("", true),
    (hasBeenAuthenticated.value)
      ? (_openBlock(), _createBlock(PandaMenu, { key: 2 }))
      : (_openBlock(), _createBlock(_unref(LoginButtons), {
          key: 3,
          class: "app-header__login"
        }))
  ]))
}
}

})